var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'ado ado' + _vm.ado + ' d-none d-md-block'},[_c('img',{attrs:{"src":require(("@/assets/ado/" + _vm.ado + ".svg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }